
export const pricing = {
  'request.pricing': 'Solicitar precios',
  'view.pricing': 'Ver precios',
  'product.pricing': 'Precios del producto',
};
